package settings.syndrome.components

import antd.form.form
import antd.form.formItem
import antd.layout.space
import antd.message.message
import antd.modal.modal
import antd.radio.radioButton
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.option
import antd.select.select
import com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomCharacteristicRule
import external.select.filterOptionFun
import kotlinext.js.Object
import react.*
import react.dom.div
import react.dom.span

external interface SyndromeIndicationSignSymptomCharacteristicEditModalProps : RProps {
    var isVisible:Boolean
    var changeVisibility:(Boolean)->Unit
    var characteristicOptions: List<SignSymptomCharacteristic>
    var syndromeIndicationSignSymptomCharacteristic: SyndromeIndicationSignSymptomCharacteristic
    var save:(syndromeIndicationSignSymptomCharacteristic: SyndromeIndicationSignSymptomCharacteristic, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<SyndromeIndicationSignSymptomCharacteristic>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    var onSaved:()->Unit
}

data class SyndromeIndicationSignSymptomCharacteristicEditModalContextData(var placeHolderFunction: (param: String) -> Unit)

val SyndromeIndicationSignSymptomCharacteristicEditModal =
    functionalComponent<SyndromeIndicationSignSymptomCharacteristicEditModalProps> { props ->

        val (editingSyndromeIndicationSignSymptomCharacteristic,setEditingSyndromeIndicationSignSymptomCharacteristic) = useState(props.syndromeIndicationSignSymptomCharacteristic)
        val (statusMessage,setStatusMessage) = useState("")

        useEffect(props.syndromeIndicationSignSymptomCharacteristic) {
            setEditingSyndromeIndicationSignSymptomCharacteristic(props.syndromeIndicationSignSymptomCharacteristic)
        }

        fun save(){
            if(editingSyndromeIndicationSignSymptomCharacteristic.signSymptomCharacteristicId.isNullOrBlank()){
                message.error("请选择特征")
                return;
            }
            if(editingSyndromeIndicationSignSymptomCharacteristic.rule == null){
                message.error("请选择应用规则")
                return;
            }
            if(editingSyndromeIndicationSignSymptomCharacteristic.weight == null){
                message.error("请选择排序位置")
                return;
            }
            setStatusMessage("正在保存中...")
            props.save(editingSyndromeIndicationSignSymptomCharacteristic,{resp->
                if(resp.ok()){
                    setStatusMessage("保存成功!")
                    props.changeVisibility(false)
                    props.onSaved()
                }else{
                    setStatusMessage("出错了，${resp.message?:"未知错误"}")
                    //message.error("出错了，${resp.message?:"未知错误"}")
                }
            },{
                //console.log(it)
                setStatusMessage("出错了，${it.message?:"未知错误"}")
                //message.error("出错了，${it.message?:"未知错误"}")
            })
        }

        div("SyndromeIndicationSignSymptomCharacteristicEditModal") {
            modal {
                attrs {
                    title = if(editingSyndromeIndicationSignSymptomCharacteristic.id.isNullOrBlank()) "添加症状" else "编辑症状"
                    visible = props.isVisible
                    onCancel = {
                        props.changeVisibility(false)
                    }
                    onOk = {
                        save()
                    }
                }
                form {
                    attrs{
                        layout = "horizontal"
                    }
                    if(!editingSyndromeIndicationSignSymptomCharacteristic.id.isNullOrBlank()){
                        formItem {
                            attrs {
                                label = "ID"
                            }
                            span{
                                +editingSyndromeIndicationSignSymptomCharacteristic.id!!
                            }
                        }
                    }
                    formItem{
                        attrs{
                            label = "症状特征"
                        }
                        radioGroup {
                            attrs {
                                value =
                                    editingSyndromeIndicationSignSymptomCharacteristic.signSymptomCharacteristicId
                                onChange = { event ->
                                    val symptom = Object.assign(
                                        SyndromeIndicationSignSymptomCharacteristic(),
                                        editingSyndromeIndicationSignSymptomCharacteristic
                                    )
                                    symptom.signSymptomCharacteristicId = event.target.value
                                    setEditingSyndromeIndicationSignSymptomCharacteristic(symptom)
                                }
                            }
                            space {
                                attrs {
                                    direction = "vertical"
                                }
                                props.characteristicOptions.forEach { characteristic ->
                                    radioButton {
                                        attrs {
                                            value = characteristic.id
                                        }
                                        +"${characteristic.name}${if (!characteristic.description.isNullOrBlank()) "(${characteristic.description})" else ""}"
                                    }
                                }
                            }
                        }
                    }

                    formItem{
                        attrs{
                            label = "应用规则"
                        }
                        radioGroup {
                            attrs{
                                value = editingSyndromeIndicationSignSymptomCharacteristic.rule
                                onChange = { event->
                                    val symptom = Object.assign(SyndromeIndicationSignSymptomCharacteristic(),editingSyndromeIndicationSignSymptomCharacteristic)
                                    symptom.rule = event.target.value
                                    setEditingSyndromeIndicationSignSymptomCharacteristic(symptom)
                                }
                            }
                            SyndromeIndicationSignSymptomCharacteristicRule.values().forEach { type ->
                                radioButton {
                                    attrs{
                                        value = type
                                    }
                                    +"${type.getLiteral()}"
                                }
                            }
                        }
                    }


                    formItem {
                        attrs {
                            label = "特征排序"
                        }

                        select<String, SelectComponent<String>> {
                            attrs {
                                mode = "default"
                                labelInValue = false
                                value = "${editingSyndromeIndicationSignSymptomCharacteristic.weight ?: ""}"
                                placeholder = "排序位置"
                                optionLabelProp = "label"
                                filterOption = ::filterOptionFun
                                //onSearch = fetchUser
                                onChange = { selected: String, any: Any ->
                                    val entity =
                                        Object.assign(SyndromeIndicationSignSymptomCharacteristic(), editingSyndromeIndicationSignSymptomCharacteristic)
                                    entity.weight = selected.toInt()
                                    setEditingSyndromeIndicationSignSymptomCharacteristic(entity)
                                }
                                style = kotlinext.js.js { width = "100%" }
                            }
                            IntRange(1, 30).forEach { opt ->
                                option {
                                    attrs {
                                        label = "${opt}"
                                        value = "${opt}"
                                    }
                                    +"${opt}"
                                }
                            }
                        }
                    }

                    if(!statusMessage.isNullOrBlank()){
                        formItem{
                            span{
                                +"${statusMessage}"
                            }
                        }
                    }
                }
            }

        }
    }
